<template>
  <div class="main-content">
    <section class="section login-form m-0 pb-0">
      <div class="container-fluid p-0">
        <div class="container-background" :class="platform">
          <div :style="{ minHeight: `${containerHeight}px`, }" class="row mt-0">
            <div class="col-12 col-md-6 col-lg-5 col-xl-5 p-0">
              <div class="w-100 h-100 d-flex justify-content-md-end justify-content-lg-end justify-content-xl-end align-items-center">
                <div :style="{ paddingRight: rightPaddingStyle }" class="online-courses-section online-courses-section-size">
                  <div class="online-courses-title online-courses-title-text pb-3">
                    Online Courses
                  </div>
                  <div class="online-courses-text online-courses-text-container py-3 text-left">
                    {{ onlineCoursesText }}
                  </div>
                  <div class="w-100 pt-3">
                    <div v-if="!isLoggedIn" class="d-flex flex-column flex-md-row flex-lg-row flex-xl-row justify-content-md-between justify-content-lg-between justify-content-xl-between align-items-center button-container">
                      <router-link
                        :to="{
                            name: 'signup',
                        }"
                      >
                        <v-btn
                          rounded
                          large
                          outlined
                          dark
                          width="180"
                          :color="primaryWhiteColor"
                        >
                          Register
                        </v-btn>
                      </router-link>
                      <router-link
                        :to="{
                            name: 'login',
                            query: { redirect: this.$route.path, },
                        }"
                      >
                        <v-btn
                          rounded
                          large
                          dark
                          width="180"
                          :color="primaryButtonColor"
                        >
                          Log In
                        </v-btn>
                      </router-link>
                    </div>
                    <div v-else class="d-flex justify-content-center justify-content-md-start justify-content-lg-start justify-content-xl-start align-items-center button-container">
                      <v-btn
                        rounded
                        large
                        outlined
                        dark
                        width="240"
                        :color="primaryWhiteColor"
                        @click="showGoToEnciteLMSWindow = true"
                      >
                        Take Courses on Encite
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-7 col-xl-7 p-0 d-flex justify-content-center align-items-center">
              <div class="courses-image-container">
                <img
                  :src="require('@assetsImages/OnlineCoursesImage.png')"
                  class="courses-image"
                  alt="Encite Courses"
                />
              </div>
            </div>
          </div>
          <div 
            v-if="showGoToEnciteLMSWindow" 
            class="encite-courses-window-container"
          >
            <div class="course-container-display course-container-size">
              <div class="course-container-text text-center px-5 mb-2">
                You are now leaving Project Spectrum to access an external webiste.
              </div>
              <div class="d-flex flex-column flex-lg-row flex-xl-row justify-content-between align-items-center button-space-between px-3 mt-2">
                <v-btn
                  rounded
                  large
                  outlined
                  dark
                  width="180"
                  :color="primaryButtonColor"
                  class="mb-md-2"
                  @click="showGoToEnciteLMSWindow = false"
                >
                  Go Back
                </v-btn>
                <v-btn
                  rounded
                  large
                  dark
                  width="180"
                  :color="primaryButtonColor"
                  @click="handOverToLMS"
                >
                  Continue
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import { isLoggedIn } from "../utils/authentication";

  export default {
    data() {
      return {
        isLoggedIn: isLoggedIn(),
        showGoToEnciteLMSWindow: false,
      };
    },
    computed: {
      onlineCoursesText(){
        return this.isLoggedIn 
                ? "Project Spectrum offers comprehensive courses on the requirements of specific CMMC levels, FOCI, and more, all through the Encite learning platform. Explore our resources and learn how they can play a vital role in enhancing your organization’s cybersecurity posture. These micro-learning courses are short and easily digested, but they’re packed full of valuable information. Be sure to visit the Project Spectrum website and take advantage of all our specialized, self-paced courses."
                : "Login or Register with our training platform to view our current, no-cost offerings and be sure to check back often as we are regularly developing and adding new material to the platform to help us remain one step ahead of our adversaries in cyberspace."
      },
      isMobile() {
        return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
      },
      platform() {
        return this.isMobile ? 'mobile' : 'desktop';
      },
      rightPaddingStyle() {
        return !this.isMobile
                ? !this.isLoggedIn 
                    ? '100px' 
                    : '50px'
                : '0'; 
      },
    },
    methods: {
      handOverToLMS() {
        try {
          const vuexData = localStorage.getItem('vuex');
          this.openEnciteLMSCoursesTab(vuexData);
        }
        catch(error) {
          console.error('Error creating authenticated link:', error);
          window.open(`https://student.encite.io/course-catalog`, '_blank');          
        }
        finally {
          this.showGoToEnciteLMSWindow = false;
        }
      },
      openEnciteLMSCoursesTab(vuexData) {
        try {
          vuexData = JSON.parse(localStorage.getItem('vuex'));
        } catch (error) {
          console.error('Error parsing Vuex data:', error);
          window.open(`https://student.encite.io/course-catalog`, '_blank');
          return;
        }

        // Extract the tokens from Vuex store
        const accessToken = vuexData.accessToken;
        const idToken = vuexData.idToken;
        const refreshToken = vuexData.refreshToken;
        const userObject = vuexData.user;

        // Check if we have the required tokens
        if (!accessToken || !idToken || !refreshToken || !userObject) {
          console.error("The user token items are undefined");
          window.open(`https://student.encite.io/course-catalog`, '_blank');
          return;
        }

        // Encode the user object for URL
        const encodedUser = encodeURIComponent(JSON.stringify(userObject));
        window.open(`https://student.encite.io/handoff#accessToken=${accessToken}&idToken=${idToken}&refreshToken=${refreshToken}&redirect=course-catalog?category&user=${encodedUser}`, '_blank');
      }
    },
    mounted(){
      this.computePageContainerHeight();
      window.addEventListener('resize', this.computePageContainerHeight);
    },
    destroyed(){
      window.removeEventListener('resize', this.computePageContainerHeight);
    },
  }
</script>

<style scoped>
  .login-form {
    top: 0 !important;
    padding-bottom: 12px !important;
  }
  .container-background {
    background-image: url('~@assetsImages/OnlineCoursesBackgroundBanner.png');
    background-position: center center;
    background-size: cover;
    position: relative;
    min-width: 370px;
  }
  .courses-image-container {
    width: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .courses-image {
    width: 100%;
    aspect-ratio: 16 / 9;
  }
  .online-courses-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
  }
  .online-courses-title {
    color: #ffffff;
    font-family: GeomGraphic;
    font-style: normal;
    font-weight: 400;
  }
  .online-courses-text {
    color: #E6E6E6;
    font-family: Rajdhani;
    font-size: clamp(15px, 2vw, 16px);
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .encite-courses-window-container {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
  }
  .course-container-display {
    height: auto;
    padding: 15px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #d5d7d7;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .course-container-text {
    color: #272727;
    text-align: center;
    font-family: Rajdhani;
    font-size: clamp(18px, 2vw, 20px);
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }

  .desktop .online-courses-section-size {
    width: 80%;
    height: 95%;
  }
  .desktop .online-courses-title-text {
    font-size: clamp(60px, 2vw, 75px);
    line-height: 4rem;
  }
  .desktop .course-container-size {
    width: 450px; 
    padding: 30px 15px;
  }
  .desktop .button-container {
    gap: 10px;
  }

  .mobile {
    padding-top: 40px;
  }
  .mobile .online-courses-section-size {
    width: 100%;
    height: 100%;
  }
  .mobile .online-courses-title-text {
    width: 100%;
    font-size: clamp(24px, 2vw, 60px);
    line-height: 3rem;
    text-align: center;
  }
  .mobile .online-courses-text-container, 
  .mobile .button-container {
    padding-left: 30px;
    padding-right: 30px;
    gap: 15px;
  }
  .mobile .course-container-size {
    width: 300px; 
    padding: 15px;
  }
  .mobile .button-space-between {
    gap: 10px;
  }

</style>